import numeral from 'numeral'

export default (money: number) => numeral(money).format('$0.00')
